import { SessionService } from './session';
import { Injectable } from '@angular/core';

@Injectable()
export class FiltersService {

  constructor(public sessionService: SessionService){}

  queryParams = {
    from_date: '',
    to_date: '',
    latitude: '',
    longitude: '',
    radius: '',
    touched: false,
    structure: { lower: 5, upper: 23 },
    services: [],
    city: this.sessionService.user.city_id,
    zones: [],
    categories: [],
    gym: []
  }

  classType=''; // e.g. "CARDIO", "FUERZA", "ZEN", "VIRTUAL", "FAVORITES"...

  myClassesType ='reserved';

  loadedAllmyClasses = false;
}



// WEBPACK FOOTER //
// ./src/services/filters.ts